export const IS_CONNECTED = '@account/IS_CONNECTED';
export type CONNECTED = typeof IS_CONNECTED;

export interface SetIsConnected {
  type: CONNECTED;
  payload: {
    isConnected: false,
  }
}

export function setIsConnected(isConnected: any): SetIsConnected {
  return {
    type: IS_CONNECTED,
    payload: {
      isConnected: isConnected
    }
  };
}